
var customFilter = {
  init: function() {
    if ($(window).width() < 768) $('.filter-title').addClass('filter-collapsed');
    if ($('.filter-contents').length > 0 && location.pathname.indexOf('/collections') > -1) {
      var paths = location.pathname.split("/");
      var url = location.origin + '/' + paths[1] + '/' + paths[2];
      var search = location.search;
      var path3 = null;
      var tags = [];
      if (paths.length > 3) {
        path3 = paths[3];
        tags = path3.split('+');
      }
      if (tags.length > 0) {
        for (var i = 0; i < tags.length; i++) {
          $('.filter-contents input[value="'+tags[i]+'"]').prop('checked', true)
        }

        for (var j = 0; j < $('.filter-contents').length; j++) {
          var checkedTags = $('.filter-contents').eq(j).find('input:checked');
          if (checkedTags.length > 0) {
            for (var i = checkedTags.length - 1; i >= 0; i--) {
              checkedTags.eq(i).closest('li').prependTo($('.filter-contents').eq(j))
            }
            $('.filter-contents').eq(j).prev('h4').find('.filter-clear').show()
            // $('#clear_type_filter').show();
            // $('#type_filter input:not(:checked)').closest('li').hide();  
          } 
        }
        
        $('.filter-clear').on('click', function() {
          $(this).closest('h4').next('.filter-contents').find('input').prop('checked', false);
          $(this).closest('h4').next('.filter-contents').find('input').trigger('change');
          // $('#type_filter input').prop('checked', false);
          // $('#type_filter input').trigger('change');
        });
      }
      $('.filter-arrow').on('click', function() {
        $(this).closest('h4').toggleClass('filter-collapsed')
      });
      Array.prototype.remove = function() {
          var what, a = arguments, L = a.length, ax;
          while (L && this.length) {
              what = a[--L];
              while ((ax = this.indexOf(what)) !== -1) {
                  this.splice(ax, 1);
              }
          }
          return this;
      };

      $('.filter-contents input').on('change', function() {
        var tag = $(this).val();
        if ($(this).prop('checked')) {
          tags.push(tag);
          var previous_tags = $(this).closest('.filter-contents').find('input:checked').not($(this));
          for (var i = 0; i < previous_tags.length; i++) {
            tags.remove(previous_tags.eq(i).val())
          }
        } else {
          tags.remove(tag)
        }

        tags = tags.filter( customFilter.onlyUnique );
        url = location.origin + '/' + paths[1] + '/' + paths[2];
        if (tags.length > 0) {
          url = url + '/' + tags.join('+')
        }
        url = url + search;
        location.href = url;
      });
    }
  },
  onlyUnique: function(value, index, self) { 
    return self.indexOf(value) === index;
  }
}

var extraTooltip = {
  init: function() {
    var tooltipTimer = null;
    $('.extra_link').on('click', function(e) {
      e.preventDefault();
      event.stopPropagation();
      window.open($(this).data('href'), '_blank');
    });
    $(window).click(function() {
      $('.thumbnail .extra-tooltip, .product_outer .extra-tooltip').remove();
      $('.product_outer').removeClass('extra_popup_opened');
    });
    $('.extra_link').mouseenter(function() {
      clearInterval(tooltipTimer);
      var length = 0;
      if ($(this).closest('.product_gallery').length > 0) {
        length = $('.product_outer .extra-tooltip').length
      } else {
        length = $(this).find('.extra-tooltip').length  
      }
      if (length == 0) {
        var target = $(this).data('target');
        // if ($(this).closest('.product_gallery').length > 0) {
        //   $('.product_outer').append($(target).html()).hide().fadeIn(200);
        //   $('.product_outer').addClass('extra_popup_opened');
        // } else {
        //   $(this).append($(target).html());  
        // }
        
        $('.extra-tooltip').find('.cancel').on('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          clearInterval(tooltipTimer);
          if ($(this).closest('.product_gallery').length > 0) {
            $(this).closest('.extra-tooltip').hide(200, function() {
              $(this).remove();
            });
          } else {
            $(this).closest('.extra-tooltip').remove();  
          }
          
          $('.product_outer').removeClass('extra_popup_opened');
        });
        $('.extra-tooltip').find('.extra-tooltip-details').on('click', function() {
          window.open(location.origin + $(this).data('href'));
        });

      } else {
        if ($(this).closest('.product_gallery').length == 0) {
          $('.thumbnail .extra-tooltip').not($(this).find('.extra-tooltip')[0]).remove()
        }
        $('.product_outer').removeClass('extra_popup_opened');
      }
    })
    .mouseleave(function() {
      if ($(this).closest('.product_gallery').length > 0) return;
      var instance = $(this);
      var timeInterval = 3000;
      if (instance.closest('.thumbnail').length > 0) timeInterval = 1000;
      tooltipTimer = setInterval(function(){
        instance.find('.extra-tooltip').remove();
        $('.product_outer').removeClass('extra_popup_opened');
        if (instance.closest('.product_gallery').length > 0) {
          $('.product_outer .extra-tooltip').remove()
        }
      }, timeInterval);
    });
    $('.extra_link').mouseover(function() {
      if ($(this).closest('.product_gallery').length == 0) {
        $('.thumbnail .extra-tooltip').not($(this).find('.extra-tooltip')[0]).remove()
      }
    });
  }
}


var ajaxCart = {
  init: function() {
    $('.cart_button').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      $.getJSON('/cart.js', function(cart) {
        ajaxCart.refreshCart(cart);
      });
      $('body').addClass('cart_opened');
    });
    $(window).click(function() {
      if ($('body').hasClass('cart_opened')) $('body').removeClass('cart_opened');
    });

    $('#side_cart').click(function(event){
      event.stopPropagation();
    });
    $('#cart_close').on('click', function(event) {
      event.stopPropagation();
      $('body').removeClass('cart_opened');
    });
    $('.available-qty-btn').fancybox({type: "inline"});
  },
  refreshCart: function(cart) {
    $(".cart_count").empty();
    $cartBtn = $(".cart_count");
    var cart_items_html = "";
    $cartBtn.empty();
    if (cart.item_count == 0) {
      $('.js-empty-cart__message').removeClass('hidden');
      $('.js-cart_content__form').addClass('hidden');
    } else {
      $cartBtn.text('(' + cart.item_count + ')');
      $('.js-empty-cart__message').addClass('hidden');
      $('.js-cart_content__form').removeClass('hidden');

      $.each(cart.items, function(index, item) {
        console.log(item);
        var splits = item.title.split("|");
        var title = splits[splits.length - 1];
        cart_items_html += '<li class="cart_item clearfix" data-product-id="' + item.product_id + '">';
        if (item.image) {
          cart_items_html += '<a href="' + item.url +'" class="cart_image">' + '<img src="' + item.image + '" alt="' + title + '" />' + '</a>';
        }

        cart_items_html += '<div class="cart_item__content">';
          cart_items_html += '<div class="cart_item__details"><div class="item_title">' + title;

          if(item.properties) {
            $.each(item.properties, function(title, value) {
              if (value) {
                cart_items_html += '<div class="line-item">' + title +': ' + value + '</div>';
              }
            });
          }
          cart_items_html += '</div>';
            cart_items_html += '<div class="item_price">' + Shopify.formatMoney(item.price, "$\{\{amount\}\}") + '</div>';
          cart_items_html += '</div>';

          cart_items_html += '<div class="cart_item__actions">';
            cart_items_html += '<span class="remove_item" data-variant-id="' + item.variant_id + '">REMOVE</span>';
            cart_items_html += '<span class="item_qty" data-variant-id="' + item.variant_id + '" data-product-handle="' + item.handle + '">Qty: <span class="qty-minus qty-icon">&ndash;</span><span class="qty-number">' + item.quantity + '</span><span class="qty-plus qty-icon">+</span><input type="hidden" name="updats[' + item.variant_id + ']" value="' + item.quantity + '"></span>';
          cart_items_html += '</div>';
        cart_items_html += '</div>';
        cart_items_html += '</li>';
      });
      $('.side-cart_main .js-cart_content__form ul').html(cart_items_html);
      $('.side-cart_main .side-cart_total span').text(Shopify.formatMoney(cart.total_price, "$\{\{amount\}\}") + ' AUD');
      $('#side_cart .remove_item').on('click', function() {
        var variant_id = $(this).data('variant-id');
        ajaxCart.updateCart(variant_id, 0);
      });
      $('#side_cart .qty-minus').on('click', function() {
        var variant_id = $(this).closest('.item_qty').data('variant-id');
        var qty = parseInt($(this).closest('.item_qty').find('.qty-number').text());
        var new_qty = qty - 1;
        var handle = $(this).closest('.item_qty').data('product-handle');
        var adjusted_qty = ajaxCart.checkVariantQty(handle, variant_id, new_qty);
        // ajaxCart.updateCart(variant_id, adjusted_qty);
      });
      $('#side_cart .qty-plus').on('click', function() {
        var variant_id = $(this).closest('.item_qty').data('variant-id');
        var qty = parseInt($(this).closest('.item_qty').find('.qty-number').text());
        var new_qty = qty + 1;
        var handle = $(this).closest('.item_qty').data('product-handle');
        var adjusted_qty = ajaxCart.checkVariantQty(handle, variant_id, new_qty);
        // ajaxCart.updateCart(variant_id, adjusted_qty);
      });
      // ajaxCart.updateValuablePackages(cart);
    }
  },
  checkVariantQty: function(handle, variant_id, new_qty) {
    $.getJSON('/products/' + handle + '.json', function(product) {
      var adjusted_qty = 0;
      if (product && product['product'] != null && product['product']['variants'].length > 0) {
        var adjusted_qty = product['product']['variants'][0].inventory_quantity;
        if (adjusted_qty > 0) {
          $('[data-available-pieces]').html('Unfortunately, we only have <b>' + (adjusted_qty > 1 ? adjusted_qty + ' pieces' : '1 piece') + '</b> currently available.  We have adjusted your order accordingly.');
        } else {
          $('[data-available-pieces]').html('This product is out of stock.');  
        }
        if (adjusted_qty < new_qty || adjusted_qty == 0) {
          $('.available-qty-btn').trigger('click');
          ajaxCart.updateCart(variant_id, adjusted_qty);
        } else {
          ajaxCart.updateCart(variant_id, new_qty);
          adjusted_qty = new_qty;
        }
        
        return adjusted_qty;
      }
      $('[data-available-pieces]').html('This product is out of stock.');
      $('.available-qty-btn').trigger('click');
      ajaxCart.updateCart(variant_id, adjusted_qty);
      return 0;
    });
  },
  updateCart: function(variant_id, qty) {
    var data = {updates: {}};
    data.updates[variant_id] = qty;
    $.ajax({
      url: '/cart/update.js', 
      method: 'post',
      data: data,
      dataType: 'json',
      success: function(cart) {
        console.log(cart);
        ajaxCart.refreshCart(cart);
      }
    });
  },
  updateValuablePackages: function(cart) {
    $.each(cart.items, function(index, item) {
      var product_id = item.product_id;
      var handle = item.handle;
      $.getJSON('/products/' + handle + '.json', function(data) {
        var tags = data.product.tags;
        if (typeof tags != 'undefined' && tags != null && tags != '' && tags.indexOf('Valuable Extra') >= 0) {
          var extra_html = '<div class="valuable_extra">';
          if (tags.indexOf('Lens Valuable Extras Package') >= 0) {
            extra_html += '<a href="/pages/michaels-valuable-extras-for-lenses" target="_blank"><img src="https://cdn.shopify.com/s/files/1/1288/5975/files/Valuable_Extras_172_Large_f16a8b63-7138-40f2-8679-45a4f24a5252.png?15010"></a>'
          } else if (tags.indexOf('DSLR Valuable Extras Package') >= 0) {
            extra_html += '<a href="/pages/michaels-valuable-extras-for-mirrorless-dslr-cameras" target="_blank"><img src="https://cdn.shopify.com/s/files/1/1288/5975/files/Valuable_Extras_393_Large_ebbe43db-e9fa-45a1-873e-500093fc0c55.png?15010"></a>'
          } else if (tags.indexOf('Compact Camera Valuable Extras Package') >= 0) {
            extra_html += '<a href="/pages/michaels-valuable-extras-for-point-shoot-cameras" target="_blank"><img src="https://cdn.shopify.com/s/files/1/1288/5975/files/Valuable_Extras_171_Large_740b52da-7548-465f-95fc-9704f7d5c70e.png?15010"></a>'
          } else if (tags.indexOf('Video Camera Valuable Extras Package') >= 0) {
            extra_html += '<a href="/pages/michaels-valuable-extras-for-video-cameras" target="_blank"><img src="https://cdn.shopify.com/s/files/1/1288/5975/files/Valuable_Extras_Stamp_05_149_Video.png?v=1581925080"></a>'
          }
          extra_html += '</div>';
          $('.cart_item[data-product-id="' + product_id + '"] .cart_item__content').find('valuable_extra').remove();
          $('.cart_item[data-product-id="' + product_id + '"] .cart_item__content').append(extra_html);
        }
      });
    });
  }
}

$(function() {
  $('.homepage_slider').each(function() {
    var homeSlider = $(this);
    var video_embed = (homeSlider.data('video_embed') == "true" ? true : false);
    var speed = homeSlider.data('speed');
    var slideshow_animation = homeSlider.data('slideshow_animation');
    var slide_params = {
      touch: false,
      pauseOnHover: video_embed,
      video: video_embed,
      controlNav: true,
      animation: slideshow_animation,
    }
    if (slideshow_animation == 'slide') slide_params.useCSS = false;
    if (typeof speed == 'undefined' || speed == null || speed == '')
      slide_params.slideshowSpeed = 10*1000
    else
      slide_params.slideshowSpeed = parseInt(speed)*1000
    homeSlider.flexslider(slide_params);
  });

  $('.mps_slider').flexslider({touch: false, controlNav: false, animation: "fade", slideshowSpeed: 5000 });

  $('.slider').flexslider({touch: false, controlNav: false, animation: "fade" });

  $('.slider-no-nav').flexslider({touch: false, controlNav: false, directionNav: false, animation: "fade" });

  $('.slider-no-nav-quick').flexslider({touch: false, controlNav: false, directionNav: false, animation: "fade", slideshowSpeed: 4000 });

  $('.product_slider').flexslider({
    startAt: parseInt($('#featured_image').data('index'), 10),
    touch: true,
    pauseOnHover: true,
    controlNav: "thumbnails",
    directionNav: false,
  
  slideshow: false,
  
  slideshowSpeed: 6*1000
});

  $('#menu-toggle').on('click', function() {
    $('.toggle_menu').toggle();
    $(this).toggleClass('open');
//     $('.tmenu_app_mobile .tmenu_item_has_child > a').attr('href', 'javascript:;');
//     $('.tmenu_item_has_child').on('click', function() {
//       $('.tmenu_app_mobile .tmenu_item_has_child > a').attr('href', 'javascript:;');
//       $('.tmenu_item_has_child > a').off('click');
//       $('.tmenu_item_has_child > a').on('click', function() {
//         $(this).closest('.tmenu_item_has_child').toggleClass('tmenu_item_active')
//       })
//     });
    
  });

  function searchCall(q) {
    var search_string = '';
    $.post(
            "https://api.michaels.com.au/shopify_search",
            {search: q},
            function(returnedData, status) {
              if(status == "success") {
                var i = 0;
                var first = true;
                for(i = 0; i < returnedData.length; i++) {
                  if(first) {
                    first = false;
                  } else {
                    search_string += " OR ";
                  }
                  search_string += "id:" + returnedData[i];
                }
                if(returnedData.length == 0){
                  search_string = q;
                }
                self.location = '/search?type=product&q=' + search_string;
              } else {
                self.location = '/search?type=product&q=' + q;
              }
            }
    );
  }

  window.onload=window.onpageshow= function() {
    $('.search_container').each(function() {
      $(this).show();
    });
    $('.search_loading').each(function () {
      $(this).hide();
    });
  };

  $(document).ready(function() {
    var search_string = '';
    $('.search_box').each(function() {
      if($(this).val().length > 0) {
        search_string = $(this).val();
      }
    });
    if (search_string.length > 0) {
      $('.search_box').each(function() {
        $(this).val('');
      });
    }
  });

  $('.search').each(function(){
    $(this).submit (function() {
      $('.search_container').each(function() {
        $(this).hide();
      });
      $('.search_loading').each(function () {
        $(this).show();
      });
      $('.search_box').each(function() {
        if($(this).val().trim() != "") {
          location.href = '/apps/michaels/search?page=0&keyword=' + encodeURIComponent($(this).val().trim())
          // searchCall($(this).val());
        }
      });
      return false;
    });
  });

  $('.lightbox').fancybox();
  /*$(".fancybox").fancybox({padding: 0, wrapCSS: 'gallery'});*/
  $(".fancybox").fancybox({padding: 0, wrapCSS: 'gallery', beforeShow:function(){}});
  $('.close').on('click', function() { $.fancybox.close(); });
  if($('.flexslider img').length == 1) { $('.flexslider .flex-direction-nav').hide() }

  if ($(window).width() >= 959) {
    $('.thumbnail').hover(function(){ $('.quick_shop', this).show(); }, function(){ $('.quick_shop', this).hide(); })
    var modal_width = '840px';
    if($(window).width() >= 1200 || $('html').hasClass('ie')) {
      modal_width = '1080px'
    }
    $(".quick_shop").fancybox({
      width: modal_width,
      height: 'auto',
      autoSize: false,
      padding: [0, 20, 0, 20]
    });
  }

  

  

  $('#tag_filter').change(function() { window.location = $('#tag_filter option:selected').val(); });
  $('.update_subtotal').click(function() { $("#cart_form").submit(); return false; });
  $("#cart_form input[type='number']").change(function() {$("#cart_form").submit(); });

  

  Shopify.queryParams = {};
  if (location.search.length) {
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
      aKeyValue = aCouples[i].split('=');
      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
      }
    }
  }

  var tabs = $('ul.tabs');
  tabs.each(function(i) {
    var tab = $(this).find('> li > a');
    tab.click(function(e) {
      var contentLocation = $(this).attr('href');
      if(contentLocation.charAt(0)=="#") {
        e.preventDefault();
        tab.removeClass('active');
        $(this).addClass('active');
        $(this).parents('ul.tabs').next().find(contentLocation).show().css({'display': 'block'}).addClass('active').siblings().hide().removeClass('active');
      }
    });
  });

  $('.toggle').click(function(e) {
    if ($(window).width() <= 767) {
      var $toggle = $(this);
      if($toggle.next('ul').is(':visible')) {
        $toggle.next('ul').hide();
        $toggle.children('span').html('+');
      } else {
        $toggle.next('ul').show();
        $toggle.children('span').html('-');
      }
    }
    e.preventDefault();
    return false;
  });

  var $contact_form = $('.newsletter .contact-form');
  $contact_form.each(function() {
    var $cf = $(this);
    $cf.on("submit", function (e) {
      
      setTimeout($.fancybox.close, 3000);
    });
  });

  var $notify_form = $('.notify_form .contact-form');
  $notify_form.each(function() {
    var $nf = $(this);
    $nf.on("submit", function (e) {
      if($nf.find('.notify_email').val() != "") {
        $.ajax({
          type: $nf.attr('method'),
          url: $nf.attr('action'),
          data: $nf.serialize(),
          success: function (data) {
            $notify_form.fadeOut("slow", function(){
              $nf.prev('.message').html("Thanks! We will notify you when this product becomes available!");
            });
          }
        });
      } else {
        $nf.prev('.message').html("Please provide a valid email address.");
      }
      e.preventDefault();
    });
  });

  


  
  $(function() {
    /**
     * author Remy Sharp
     * url http://remysharp.com/2009/01/26/element-in-view-event-plugin/
     * fork https://github.com/zuk/jquery.inview
     */
    (function(e){function m(){var b=window.innerHeight;if(b)return b;var f=document.compatMode;if(f||!e.support.boxModel)b="CSS1Compat"===f?document.documentElement.clientHeight:document.body.clientHeight;return b}var n=function(b,f){function e(){null!==a?c=!0:(c=!1,b(),a=setTimeout(function(){a=null;c&&e()},f))}var c=!1,a=null;return e}(function(){var b=window.pageYOffset||document.documentElement.scrollTop||document.body.scrollTop,f=b+m(),g=[];e.each(e.cache,function(){this.events&&this.events.inview&&
    g.push(this.handle.elem)});e(g).each(function(){var c=e(this),a;a=0;for(var d=this;d;d=d.offsetParent)a+=d.offsetTop;var d=c.height(),k=a+d,d=c.data("inview")||!1,h=c.data("offset")||0,g=a>b&&k<f,l=k+h>b&&a<b,h=a-h<f&&k>f;g||l||h||a<b&&k>f?(a=h?"top":l?"bottom":"both",d&&d===a||(c.data("inview",a),c.trigger("inview",[!0,a]))):!g&&d&&(c.data("inview",!1),c.trigger("inview",[!1]))})},100);e(window).on("checkInView.inview click.inview ready.inview scroll.inview resize.inview",n)})(jQuery);

    var $target = $("#instafeed");
    $target.bind('inview', function (event, visible, topOrBottomOrBoth) {
      if ($target.html() != '' || (typeof Instafeed == 'undefined')) return;
      if (visible == true) {
        var feed = new Instafeed({
          get: 'user',
          userId: 'self',
          accessToken: '278169570.bd54f22.1961cbb9bbe941f8a0e816c06cae9da6',
          clientId: $target.data('client-id'),
          limit: '15',
          filter: function(image) {
            var width = $(window).width();
            if (image.type == 'image' || image.type == 'carousel') {
                image.template = '<img src="' + (width>1600 ? image.images.standard_resolution.url : image.images.low_resolution.url) + '" />';
            } else {
                image.template = '<video width="100%" controls loop><source src="' + (width>1600 ? image.videos.standard_resolution.url : image.videos.low_resolution.url) + '" type="video/mp4"/></video>';
            }
            return true;
          },
          template: '<div class="instas"><a href="{{link}}">{{model.template}}</a></div>',
          resolution: 'low_resolution',
          after: function() {
            if($('#instafeed .instas').length > 10) {
              $('#instafeed .instas:eq(9)').nextAll().remove()
          }
          },
        });
        feed.run();        
      }
    });

  });
  


  /*============================================================================
   Start of cart-related functionality
   ==============================================================================*/
  function ajaxSubmitCart() {
    $cart = $("#cart");
    $.ajax({
      url: '/cart.js',
      dataType: 'json',
      type: 'post',
      data: $cart.serialize(),
      success: function (data) {
        refreshCart(data);
      }
    });
  }

  function refreshCart(cart) {
    $cartBtn = $(".cart_button");
    if ($cartBtn) {
      var $cartCount = $cartBtn.find('.cart_count');
      if(cart.item_count == 0) {
        $cartCount.remove();
        $cartBtn.removeClass('active');
      } else if ($cartCount.length) {
        $cartCount.html('<span class="cart_count"> (' + cart.item_count + ')</span>');
        $cartBtn.addClass('active');
      } else {
        $cartBtn.append('<span class="cart_count"> (' + cart.item_count + ')</span>');
        $cartBtn.addClass('active');
      }
    }
  }


  
  $(".product_form").submit(function(e) {
    e.preventDefault();
    var $addToCartForm = $(this);
    var $addToCartBtn = $addToCartForm.find('.add_to_cart');
    var handle = $(this).data('handle');
    var variant_id = $(this).find('[name="id"]').val();
    var origin_qty = $(this).data('origin-qty');
    if (origin_qty == 0) {
      $('[data-available-pieces]').html('This product is out of stock.');
      $('.available-qty-btn').trigger('click');
    } else {
      $.getJSON('/cart.json', function(cart) {
        var cart_qty = 0;
        if (cart.items.length > 0) {
          for (var i = 0; i < cart.items.length; i++) {
            if (cart.items[i].variant_id == variant_id) {
              cart_qty = cart.items[i].quantity;
              break;
            }
          }
        }
        var new_qty = cart_qty + 1;
        if (new_qty > origin_qty) {
          $('[data-available-pieces]').html('Unfortunately, we only have <b>' + (origin_qty > 1 ? origin_qty + ' pieces' : '1 piece') + '</b> currently available.  We have adjusted your order accordingly.');
          $('.available-qty-btn').trigger('click');
        } else {
          $.ajax({
            url: '/cart/add.js',
            dataType: 'json',
            type: 'post',
            data: $addToCartForm.serialize(),
            beforeSend: function() {
              $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
              $addToCartBtn.find('span').removeClass("zoomIn").addClass('animated zoomOut');
            },
            success: function(itemData) {
              $addToCartBtn.find('span').text("Added").removeClass('zoomOut').addClass('fadeIn');
              $addToCartForm.find('.continue_shopping').show().addClass('animated fadeInLeft');
              $('.cart_button').trigger('click');

              window.setTimeout(function(){
                $addToCartBtn.removeAttr('disabled').removeClass('disabled');
                $addToCartBtn.find('span').addClass("fadeOut").text($addToCartBtn.data('label')).removeClass('fadeIn').removeClass("fadeOut").addClass('zoomIn');
              }, 2000);

              $.getJSON("/cart.js", function(cart) {
                refreshCart(cart);
              });
            },
            error: function(XMLHttpRequest) {
              var response = eval('(' + XMLHttpRequest.responseText + ')');
              response = response.description;
              $('.warning').remove();

              var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
              $addToCartBtn.after(warning);
              $addToCartBtn.removeAttr('disabled').removeClass('disabled');
              $addToCartBtn.find('span').text("Add to Cart").removeClass('zoomOut').addClass('zoomIn');
            }
          });
        }
      });
    }

    return false;
  });
  

  selectCallback = function(variant, selector) {
    var $product = $('.product-' + selector.product.id);
    var $notify_form = $('.notify-form-' + selector.product.id);
    var $productForm = $('form.product_form', $product);

    if (variant && variant.featured_image && $product.is(":visible")) {
      var $sliders = $('.product_gallery', $product);
      $sliders.each(function() {
        var $slider = $(this);
        if ($slider.is(":visible")) {
          var original_image = $(".flex-active-slide img", $product), new_image = variant.featured_image;
          Shopify.Image.switchImage(new_image, original_image[0], function (new_image_src, original_image, element) {
            $slider.flexslider($('[data-image-id="' + variant.featured_image.id + '"]').data('index'));
          });
        }
      });
    }

    // for quick shop
    if (variant && variant.featured_image && $product.is(":visible")) {
      var $popimg = $('.modal_image', $product);
      var pop_original_image = $(".modal_image img", $product), new_image = variant.featured_image;
      Shopify.Image.switchImage(new_image, pop_original_image[0], function (new_image_src, pop_original_image, element) {
        $popimg.html('<img src="' + variant.featured_image.src + '"/>');
      });
    }

    if (variant) {
      $('.sku span', $product).text(variant.sku);
      $(".notify_form_message", $product).attr("value", $(".notify_form_message", $product).data('body') + " - " + variant.title);

      
    }

    if (variant && variant.available == true) {
      if(variant.price < variant.compare_at_price){
        $('.was_price', $product).html(Shopify.formatMoney(variant.compare_at_price, $productForm.data('money-format')))
      } else {
        $('.was_price', $product).text('')
      }

      if (variant.inventory_management == "shopify" && variant.inventory_quantity > 0) {
        
        if (variant.inventory_quantity == 1) {
          items_left_text = "item left";
        } else {
          items_left_text = "items left";
        }
        $('.items_left', $product).html("<p><em>" + variant.inventory_quantity + " " + items_left_text +"</em></p>");
        
        if(variant.inventory_policy == "deny") {
          $('.quantity', $product).attr('max', variant.inventory_quantity);
        }
      } else {
        $('.items_left', $product).text('');
        $('.quantity', $product).removeAttr('max');
      }

      $('.sold_out', $product).text('');
      if (variant.price > 0) {
        $('.current_price', $product).html(Shopify.formatMoney(variant.price, $productForm.data('money-format')));
      } else {
        $('.current_price', $product).html("Call for Pricing");
      }
      $('.add_to_cart', $product).removeClass('disabled').removeAttr('disabled').find('span').text($('.add_to_cart', $product).data('label'));
      $notify_form.hide();
    } else {
      var message = variant ? "Usually Ships In 7-14 Business Days" : "Unavailable";
      $('.was_price', $product).text('');
      $('.current_price', $product).text('');
      $('.items_left', $product).text('');
      $('.quantity', $product).removeAttr('max');
      $('.sold_out', $product).text(message);
      $('.add_to_cart', $product).addClass('disabled').attr('disabled', 'disabled').find('span').text(message);
      $notify_form.fadeIn();
    }

    
  };
});

function htmlEncode(value){
  if (value) {
    return $('<div/>').text(value).html();
  } else {
    return '';
  }
}

/* option_selection.js */
function floatToString(t,e){var o=t.toFixed(e).toString();return o.match(/^\.\d+/)?"0"+o:o}if("undefined"==typeof Shopify)var Shopify={};Shopify.each=function(t,e){for(var o=0;o<t.length;o++)e(t[o],o)},Shopify.map=function(t,e){for(var o=[],i=0;i<t.length;i++)o.push(e(t[i],i));return o},Shopify.arrayIncludes=function(t,e){for(var o=0;o<t.length;o++)if(t[o]==e)return!0;return!1},Shopify.uniq=function(t){for(var e=[],o=0;o<t.length;o++)Shopify.arrayIncludes(e,t[o])||e.push(t[o]);return e},Shopify.isDefined=function(t){return"undefined"==typeof t?!1:!0},Shopify.getClass=function(t){return Object.prototype.toString.call(t).slice(8,-1)},Shopify.extend=function(t,e){function o(){}o.prototype=e.prototype,t.prototype=new o,t.prototype.constructor=t,t.baseConstructor=e,t.superClass=e.prototype},Shopify.locationSearch=function(){return window.location.search},Shopify.locationHash=function(){return window.location.hash},Shopify.replaceState=function(t){window.history.replaceState({},document.title,t)},Shopify.urlParam=function(t){var e=RegExp("[?&]"+t+"=([^&#]*)").exec(Shopify.locationSearch());return e&&decodeURIComponent(e[1].replace(/\+/g," "))},Shopify.newState=function(t,e){var o;return o=Shopify.urlParam(t)?Shopify.locationSearch().replace(RegExp("("+t+"=)[^&#]+"),"$1"+e):""===Shopify.locationSearch()?"?"+t+"="+e:Shopify.locationSearch()+"&"+t+"="+e,o+Shopify.locationHash()},Shopify.setParam=function(t,e){Shopify.replaceState(Shopify.newState(t,e))},Shopify.Product=function(t){Shopify.isDefined(t)&&this.update(t)},Shopify.Product.prototype.update=function(t){for(property in t)this[property]=t[property]},Shopify.Product.prototype.optionNames=function(){return"Array"==Shopify.getClass(this.options)?this.options:[]},Shopify.Product.prototype.optionValues=function(t){if(!Shopify.isDefined(this.variants))return null;var e=Shopify.map(this.variants,function(e){var o="option"+(t+1);return void 0==e[o]?null:e[o]});return null==e[0]?null:Shopify.uniq(e)},Shopify.Product.prototype.getVariant=function(t){var e=null;return t.length!=this.options.length?e:(Shopify.each(this.variants,function(o){for(var i=!0,r=0;r<t.length;r++){var n="option"+(r+1);o[n]!=t[r]&&(i=!1)}return 1==i?void(e=o):void 0}),e)},Shopify.Product.prototype.getVariantById=function(t){for(var e=0;e<this.variants.length;e++){var o=this.variants[e];if(t==o.id)return o}return null},Shopify.money_format="$",Shopify.formatMoney=function(t,e){function o(t,e){return"undefined"==typeof t?e:t}function i(t,e,i,r){if(e=o(e,2),i=o(i,","),r=o(r,"."),isNaN(t)||null==t)return 0;t=(t/100).toFixed(e);var n=t.split("."),a=n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+i),s=n[1]?r+n[1]:"";return a+s}"string"==typeof t&&(t=t.replace(".",""));var r="",n=/\{\{\s*(\w+)\s*\}\}/,a=e||this.money_format;switch(a.match(n)[1]){case"amount":r=i(t,2);break;case"amount_no_decimals":r=i(t,0);break;case"amount_with_comma_separator":r=i(t,2,".",",");break;case"amount_no_decimals_with_comma_separator":r=i(t,0,".",",")}return a.replace(n,r)},Shopify.OptionSelectors=function(t,e){return this.selectorDivClass="selector-wrapper",this.selectorClass="single-option-selector",this.variantIdFieldIdSuffix="-variant-id",this.variantIdField=null,this.historyState=null,this.selectors=[],this.domIdPrefix=t,this.product=new Shopify.Product(e.product),this.onVariantSelected=Shopify.isDefined(e.onVariantSelected)?e.onVariantSelected:function(){},this.replaceSelector(t),this.initDropdown(),e.enableHistoryState&&(this.historyState=new Shopify.OptionSelectors.HistoryState(this)),!0},Shopify.OptionSelectors.prototype.initDropdown=function(){var t={initialLoad:!0},e=this.selectVariantFromDropdown(t);if(!e){var o=this;setTimeout(function(){o.selectVariantFromParams(t)||o.fireOnChangeForFirstDropdown.call(o,t)})}},Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown=function(t){this.selectors[0].element.onchange(t)},Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown=function(t){var e=this.selectVariantFromParams(t);e||this.selectVariantFromDropdown(t)},Shopify.OptionSelectors.prototype.replaceSelector=function(t){var e=document.getElementById(t),o=e.parentNode;Shopify.each(this.buildSelectors(),function(t){o.insertBefore(t,e)}),e.style.display="none",this.variantIdField=e},Shopify.OptionSelectors.prototype.selectVariantFromDropdown=function(t){var e=document.getElementById(this.domIdPrefix).querySelector("[selected]");if(e||(e=document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')),!e)return!1;var o=e.value;return this.selectVariant(o,t)},Shopify.OptionSelectors.prototype.selectVariantFromParams=function(t){var e=Shopify.urlParam("variant");return this.selectVariant(e,t)},Shopify.OptionSelectors.prototype.selectVariant=function(t,e){var o=this.product.getVariantById(t);if(null==o)return!1;for(var i=0;i<this.selectors.length;i++){var r=this.selectors[i].element,n=r.getAttribute("data-option"),a=o[n];null!=a&&this.optionExistInSelect(r,a)&&(r.value=a)}return"undefined"!=typeof jQuery?jQuery(this.selectors[0].element).trigger("change",e):this.selectors[0].element.onchange(e),!0},Shopify.OptionSelectors.prototype.optionExistInSelect=function(t,e){for(var o=0;o<t.options.length;o++)if(t.options[o].value==e)return!0},Shopify.OptionSelectors.prototype.insertSelectors=function(t,e){Shopify.isDefined(e)&&this.setMessageElement(e),this.domIdPrefix="product-"+this.product.id+"-variant-selector";var o=document.getElementById(t);Shopify.each(this.buildSelectors(),function(t){o.appendChild(t)})},Shopify.OptionSelectors.prototype.buildSelectors=function(){for(var t=0;t<this.product.optionNames().length;t++){var e=new Shopify.SingleOptionSelector(this,t,this.product.optionNames()[t],this.product.optionValues(t));e.element.disabled=!1,this.selectors.push(e)}var o=this.selectorDivClass,i=this.product.optionNames(),r=Shopify.map(this.selectors,function(t){var e=document.createElement("div");if(e.setAttribute("class",o),i.length>1){var r=document.createElement("label");r.htmlFor=t.element.id,r.innerHTML=t.name,e.appendChild(r)}return e.appendChild(t.element),e});return r},Shopify.OptionSelectors.prototype.selectedValues=function(){for(var t=[],e=0;e<this.selectors.length;e++){var o=this.selectors[e].element.value;t.push(o)}return t},Shopify.OptionSelectors.prototype.updateSelectors=function(t,e){var o=this.selectedValues(),i=this.product.getVariant(o);i?(this.variantIdField.disabled=!1,this.variantIdField.value=i.id):this.variantIdField.disabled=!0,this.onVariantSelected(i,this,e),null!=this.historyState&&this.historyState.onVariantChange(i,this,e)},Shopify.OptionSelectorsFromDOM=function(t,e){var o=e.optionNames||[],i=e.priceFieldExists||!0,r=e.delimiter||"/",n=this.createProductFromSelector(t,o,i,r);e.product=n,Shopify.OptionSelectorsFromDOM.baseConstructor.call(this,t,e)},Shopify.extend(Shopify.OptionSelectorsFromDOM,Shopify.OptionSelectors),Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector=function(t,e,o,i){if(!Shopify.isDefined(o))var o=!0;if(!Shopify.isDefined(i))var i="/";var r=document.getElementById(t),n=r.childNodes,a=(r.parentNode,e.length),s=[];Shopify.each(n,function(t,r){if(1==t.nodeType&&"option"==t.tagName.toLowerCase()){var n=t.innerHTML.split(new RegExp("\\s*\\"+i+"\\s*"));0==e.length&&(a=n.length-(o?1:0));var p=n.slice(0,a),l=o?n[a]:"",c=(t.getAttribute("value"),{available:t.disabled?!1:!0,id:parseFloat(t.value),price:l,option1:p[0],option2:p[1],option3:p[2]});s.push(c)}});var p={variants:s};if(0==e.length){p.options=[];for(var l=0;a>l;l++)p.options[l]="option "+(l+1)}else p.options=e;return p},Shopify.SingleOptionSelector=function(t,e,o,i){this.multiSelector=t,this.values=i,this.index=e,this.name=o,this.element=document.createElement("select");for(var r=0;r<i.length;r++){var n=document.createElement("option");n.value=i[r],n.innerHTML=i[r],this.element.appendChild(n)}return this.element.setAttribute("class",this.multiSelector.selectorClass),this.element.setAttribute("data-option","option"+(e+1)),this.element.id=t.domIdPrefix+"-option-"+e,this.element.onchange=function(o,i){i=i||{},t.updateSelectors(e,i)},!0},Shopify.Image={preload:function(t,e){for(var o=0;o<t.length;o++){var i=t[o];this.loadImage(this.getSizedImageUrl(i,e))}},loadImage:function(t){(new Image).src=t},switchImage:function(t,e,o){if(t&&e){var i=this.imageSize(e.src),r=this.getSizedImageUrl(t.src,i);o?o(r,t,e):e.src=r}},imageSize:function(t){var e=t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);return null!=e?e[1]:null},getSizedImageUrl:function(t,e){if(null==e)return t;if("master"==e)return this.removeProtocol(t);var o=t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);if(null!=o){var i=t.split(o[0]),r=o[0];return this.removeProtocol(i[0]+"_"+e+r)}return null},removeProtocol:function(t){return t.replace(/http(s)?:/,"")}},Shopify.OptionSelectors.HistoryState=function(t){this.browserSupports()&&this.register(t)},Shopify.OptionSelectors.HistoryState.prototype.register=function(t){window.addEventListener("popstate",function(e){t.selectVariantFromParamsOrDropdown({popStateCall:!0})})},Shopify.OptionSelectors.HistoryState.prototype.onVariantChange=function(t,e,o){this.browserSupports()&&(!t||o.initialLoad||o.popStateCall||Shopify.setParam("variant",t.id))},Shopify.OptionSelectors.HistoryState.prototype.browserSupports=function(){return window.history&&window.history.replaceState};

/*
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

jQuery.cookie=function(b,j,m){if(typeof j!="undefined"){m=m||{};if(j===null){j="";m.expires=-1}var e="";if(m.expires&&(typeof m.expires=="number"||m.expires.toUTCString)){var f;if(typeof m.expires=="number"){f=new Date();f.setTime(f.getTime()+(m.expires*24*60*60*1000))}else{f=m.expires}e="; expires="+f.toUTCString()}var l=m.path?"; path="+(m.path):"";var g=m.domain?"; domain="+(m.domain):"";var a=m.secure?"; secure":"";document.cookie=[b,"=",encodeURIComponent(j),e,l,g,a].join("")}else{var d=null;if(document.cookie&&document.cookie!=""){var k=document.cookie.split(";");for(var h=0;h<k.length;h++){var c=jQuery.trim(k[h]);if(c.substring(0,b.length+1)==(b+"=")){d=decodeURIComponent(c.substring(b.length+1));break}}}return d}};

/*
* jquery-match-height 0.7.2 by @liabru
* http://brm.io/jquery-match-height/
* License MIT
*/
!function(t){"use strict";"function"==typeof define&&define.amd?define(["jquery"],t):"undefined"!=typeof module&&module.exports?module.exports=t(require("jquery")):t(jQuery)}(function(t){var e=-1,o=-1,n=function(t){return parseFloat(t)||0},a=function(e){var o=1,a=t(e),i=null,r=[];return a.each(function(){var e=t(this),a=e.offset().top-n(e.css("margin-top")),s=r.length>0?r[r.length-1]:null;null===s?r.push(e):Math.floor(Math.abs(i-a))<=o?r[r.length-1]=s.add(e):r.push(e),i=a}),r},i=function(e){var o={
byRow:!0,property:"height",target:null,remove:!1};return"object"==typeof e?t.extend(o,e):("boolean"==typeof e?o.byRow=e:"remove"===e&&(o.remove=!0),o)},r=t.fn.matchHeight=function(e){var o=i(e);if(o.remove){var n=this;return this.css(o.property,""),t.each(r._groups,function(t,e){e.elements=e.elements.not(n)}),this}return this.length<=1&&!o.target?this:(r._groups.push({elements:this,options:o}),r._apply(this,o),this)};r.version="0.7.2",r._groups=[],r._throttle=80,r._maintainScroll=!1,r._beforeUpdate=null,
r._afterUpdate=null,r._rows=a,r._parse=n,r._parseOptions=i,r._apply=function(e,o){var s=i(o),h=t(e),l=[h],c=t(window).scrollTop(),p=t("html").outerHeight(!0),u=h.parents().filter(":hidden");return u.each(function(){var e=t(this);e.data("style-cache",e.attr("style"))}),u.css("display","block"),s.byRow&&!s.target&&(h.each(function(){var e=t(this),o=e.css("display");"inline-block"!==o&&"flex"!==o&&"inline-flex"!==o&&(o="block"),e.data("style-cache",e.attr("style")),e.css({display:o,"padding-top":"0",
"padding-bottom":"0","margin-top":"0","margin-bottom":"0","border-top-width":"0","border-bottom-width":"0",height:"100px",overflow:"hidden"})}),l=a(h),h.each(function(){var e=t(this);e.attr("style",e.data("style-cache")||"")})),t.each(l,function(e,o){var a=t(o),i=0;if(s.target)i=s.target.outerHeight(!1);else{if(s.byRow&&a.length<=1)return void a.css(s.property,"");a.each(function(){var e=t(this),o=e.attr("style"),n=e.css("display");"inline-block"!==n&&"flex"!==n&&"inline-flex"!==n&&(n="block");var a={
display:n};a[s.property]="",e.css(a),e.outerHeight(!1)>i&&(i=e.outerHeight(!1)),o?e.attr("style",o):e.css("display","")})}a.each(function(){var e=t(this),o=0;s.target&&e.is(s.target)||("border-box"!==e.css("box-sizing")&&(o+=n(e.css("border-top-width"))+n(e.css("border-bottom-width")),o+=n(e.css("padding-top"))+n(e.css("padding-bottom"))),e.css(s.property,i-o+"px"))})}),u.each(function(){var e=t(this);e.attr("style",e.data("style-cache")||null)}),r._maintainScroll&&t(window).scrollTop(c/p*t("html").outerHeight(!0)),
this},r._applyDataApi=function(){var e={};t("[data-match-height], [data-mh]").each(function(){var o=t(this),n=o.attr("data-mh")||o.attr("data-match-height");n in e?e[n]=e[n].add(o):e[n]=o}),t.each(e,function(){this.matchHeight(!0)})};var s=function(e){r._beforeUpdate&&r._beforeUpdate(e,r._groups),t.each(r._groups,function(){r._apply(this.elements,this.options)}),r._afterUpdate&&r._afterUpdate(e,r._groups)};r._update=function(n,a){if(a&&"resize"===a.type){var i=t(window).width();if(i===e)return;e=i;
}n?o===-1&&(o=setTimeout(function(){s(a),o=-1},r._throttle)):s(a)},t(r._applyDataApi);var h=t.fn.on?"on":"bind";t(window)[h]("load",function(t){r._update(!1,t)}),t(window)[h]("resize orientationchange",function(t){r._update(!0,t)})});


/*!

 Name: Instagram Lite
 Dependencies: jQuery
 Author: Michael Lynch
 Author URL: http://michaelynch.com
 Date Created: January 14, 2014
 Licensed under the MIT license

 */

(function($) {

  $.fn.instagramLite = function(options) {

    // return if no element was bound
    // so chained events can continue
    if(!this.length) {
      return this;
    }

    // define default parameters
    var defaults = {
      username: null,
      clientID: null,
      limit: null,
      list: true,
      videos: false,
      urls: false,
      captions: false,
      date: false,
      likes: false,
      max_id: null,
      loadMore: null,
      error: function() {},
      success: function() {}
    }

    // define plugin
    self.plugin = this;

    // define settings
    self.plugin.settings = {}

    // merge defaults and options
    self.plugin.settings = $.extend({}, defaults, options);

    // define element
    self.el = $(this);

    // init
    self.loadContent();

    // bind load more click event
    if(plugin.settings.loadMore){
      $(plugin.settings.loadMore).on('click',function(e){
        e.preventDefault();
        self.loadContent();
      });
    }
  },

          getMaxId = function(items){

            // return id of last item
            return items[items.length-1].id;
          },

          formatCaption = function(caption) {

            var words = caption.split(' '),
                    newCaption = '';

            for(var i = 0; i < words.length; i++) {
              var word;

              if(words[i][0] == '@') {
                var a = '<a href="http://twitter.com/'+words[i].replace('@', '').toLowerCase()+'" target="_blank">'+words[i]+'</a>';
                word = a;
              } else if(words[i][0] == '#') {
                var a = '<a href="http://twitter.com/hashtag/'+words[i].replace('#', '').toLowerCase()+'" target="_blank">'+words[i]+'</a>';
                word = a;
              } else {
                word = words[i]
              }

              newCaption += word + ' ';

            }

            return newCaption;

          },

          loadContent = function(){

            // if client ID and username were provided
            if(plugin.settings.clientID) {

              // for each element
              el.each(function() {
                // construct API endpoint
                var url = 'https://api.instagram.com/v1/users/self/media/recent/?access_token='+plugin.settings.clientID+'&count='+plugin.settings.limit+'&callback=?';

                // concat max id if max id is set
                url += (plugin.settings.max_id) ? '&max_id='+plugin.settings.max_id : '';

                $.ajax({
                  type: 'GET',
                  url: url,
                  dataType: 'jsonp',
                  success: function(data) {

                    // if success status
                    if(data.meta.code === 200 && data.data.length) {

                      // for each piece of media returned
                      for(var i = 0; i < data.data.length; i++) {

                        // define media namespace
                        var thisMedia = data.data[i],
                                item;

                        // if media type is image
                        if(thisMedia.type === 'image') {

                          // construct image
                          item = '<img class="il-photo__img" src="'+thisMedia.images.standard_resolution.url+'" alt="Instagram Image" data-filter="'+thisMedia.filter+'" />';

                          // if url setting is true
                          if(plugin.settings.urls) {
                            item = '<a href="'+thisMedia.link+'" target="_blank">'+item+'</a>';
                          }

                          if(plugin.settings.captions || plugin.settings.date || plugin.settings.likes) {
                            item += '<div class="il-photo__meta">';
                          }

                          // if caption setting is true
                          if(plugin.settings.captions && thisMedia.caption) {

                            item += '<div class="il-photo__caption" data-caption-id="'+thisMedia.caption.id+'">'+self.formatCaption(thisMedia.caption.text)+'</div>';

                          }

                          // if date setting is true
                          if(plugin.settings.date) {
                            var date = new Date(thisMedia.created_time * 1000),
                                    day = date.getDate(),
                                    month = date.getMonth() + 1,
                                    year = date.getFullYear(),
                                    hours = date.getHours(),
                                    minutes = date.getMinutes(),
                                    seconds = date.getSeconds();
                            date = month +'/'+ day +'/'+ year;
                            item += '<div class="il-photo__date">'+date+'</div>';
                          }

                          // if likes setting is true
                          if(plugin.settings.likes) {
                            item += '<div class="il-photo__likes">'+thisMedia.likes.count+'</div>';
                          }

                          if(plugin.settings.captions || plugin.settings.date || plugin.settings.likes) {
                            item += '</div>';
                          }
                        }

                        if(thisMedia.type === 'video' && plugin.settings.videos) {

                          if(thisMedia.videos) {
                            var src;
                            if(thisMedia.videos.standard_resolution) {
                              src = thisMedia.videos.standard_resolution.url;
                            } else if(thisMedia.videos.low_resolution) {
                              src = thisMedia.videos.low_resolution.url;
                            } else if(thisMedia.videos.low_bandwidth) {
                              src = thisMedia.videos.low_bandwidth.url;
                            }

                            item = '<video poster="'+thisMedia.images.standard_resolution.url+'" controls>';
                            item += '<source src="'+src+'" type="video/mp4;"></source>';
                            item += '</video>';
                          }
                        }

                        // if list setting is true
                        if(plugin.settings.list) {
                          var item="<div class=\"instas\">"+item+"</div>";
                        }

                        // append image
                        el.append(item);
                      }
                      // set new max id
                      plugin.settings.max_id = self.getMaxId(data.data);
                      // execute success callback
                      plugin.settings.success.call(this);

                    } else {
                      // execute error callback
                      plugin.settings.error.call(this, data.meta.code, data.meta.error_message);
                    }

                  },
                  error: function() {
                    // recent media ajax request failed
                    // execute error callback
                    plugin.settings.error.call(this);
                  }
                });
              });
            } else {
              alert('An Instagram Access Token is required to display Instagram profile images.');
            }
          }
})(jQuery);


$(document).ready(function(){
  $( "#tabs-products" ).tabs({
      event: "mouseover",
      heightStyle: "auto"
  }).addClass( "ui-tabs-vertical ui-helper-clearfix" );
  $( "#tabs-products li" ).removeClass( "ui-corner-top" ).addClass( "ui-corner-left" );

  extraTooltip.init();
  customFilter.init();
  ajaxCart.init();

  $('.read_more').on('click', function() {
    if ($('.description_section').hasClass('expand')) {
      $('.description_section').removeClass('expand');
      $(this).html("Read More")
    } else {
      $('.description_section').addClass('expand');
      $(this).html("Hide")
    }
  });
  if ($('.description_section .description').length > 0 && $('.description_section .description').html().length < 1000 ) {
    $('.read_more_container').hide();
    $('.description_section').addClass('expand');
  }

  $('.mobile_menu > li').each(function() {
    $(this).find('ul').hide();
    if ($(this).find('li.active').length > 0) {
      $(this).find('li.active').parents('ul').not('ul.mobile_menu').show();
    }
  });

  $('.thumbnail .title').matchHeight();
  $('.thumbnail [itemprop="offers"]').matchHeight();

  $(".dropdown").hover(
          function() {
            $('.dropdown-menu', this).stop( true, true ).slideDown("fast");
            $(this).toggleClass('open');
          },
          function() {
            $('.dropdown-menu', this).stop( true, true ).slideUp("fast");
            $(this).toggleClass('open');
          }
  );
  
  
});